import clsx from "clsx";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

type DescriptionProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    size?: "2xs" | "xs" | "sm" | "md" | "lg" | "xl";
  }
>;
export const Description: FC<DescriptionProps> = ({
  className,
  children,
  size = "md",
  ...props
}) => {
  return (
    <div
      className={clsx(
        "intelli-description font-inter leading-light font-400 text-[#D7D7D7]",
        {
          "text-[12px] md:text-[14px] leading-[20px]": size === "2xs",
          "text-[12px] md:text-[16px] leading-[20px]": size === "xs",
          "text-[14px] leading-[18px] md:text-[18px] md:leading-[24px]": size === "sm",
          "text-[14px] leading-[20px] md:text-[20px] md:leading-[26px]": size === "md",
          "text-[18px] md:text-[22px]": size === "lg",
          "text-[20px] md:text-[24px]": size === "xl",
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
